export default {
  applet: {
    title: "Mini-programmes",
    appName: "Nom",
    appId: "ID",
    singleStore: "Mono-magasin",
    multiStore: "Multi-magasins",
  },
  auth: {
    title: "Autorisation canaux",
    storeMode: "Mode magasin",
    pluginAuth: "Plugins",
    userChannel: "Canal utilisateur :",
    selectMode: "Choisir le mode :",
  },
  empower: {
    title: "Autorisation",
    siteId: "ID site",
    authorized: "Autorisé",
    unauthorized: "Non autorisé",
    expired: "Expiré",
    accountLimit: "Comptes autorisés",
    serviceType: "Type de service",
    authStatus: "Statut",
    unlimited: "Illimité",
    siteUrl: "URL du site",
    siteUrlPh: "URL du site",
    siteIp: "IP du site",
    siteIpPh: "IP du site",
    authCode: "Code d'autorisation",
    authCodePh: "Code d'autorisation",
    authCodeTip:
      "Si le code expire, transmettez le domaine et l'ID site au support. Protégez votre code.",
    expireTime: "Date d'expiration",
    expireTimePh: "Date d'expiration",
  },
  edit: {
    shopNumLabel: "Nombre de magasins :",
    shopNumPh: "Saisir le nombre de magasins",
    unlimited: "Illimité",
    appPluginAuth: "Plugins applicatifs",
    appPlugin: "Plugins :",
    valuePluginAuth: "Plugins premium",
    valuePlugin: "Plugins premium :",
    otherPerm: "Autres permissions",
    serviceQq: "QQ support",
    serviceQqPh: "Saisir le QQ support",
    headerLogo: "Logo en-tête",
    sizeTip: "Taille recommandée : 720×180",
    copyright: "Texte copyright",
    copyrightPh: "Saisir le texte copyright",
    copyrightTip: "Affiché en bas de page",
    deliveryName: "Nom livraison",
    deliveryNamePh: "Nom livraison",
    deliveryNameTip: "Personnaliser le nom de livraison",
    superAuthName: "Super autorisation",
  },
  cache: {
    title: "Cache",
    redisPwd: "Mot de passe Redis",
    redisPwdPh: "Saisir le mot de passe Redis",
    redisPwdTip:
      "Saisir le mot de passe Redis (voir extensions serveur)",
    tip: "Aide",
    redisPort: "Port Redis",
    redisPortPh: "Saisir le port Redis",
    redisPortTip: "Port par défaut : 6379",
    swoolePort: "Port Swoole",
    swoolePortPh: "Saisir le port Swoole",
    swoolePortTip:
      "Ouvrir le port 9875 sur le cloud et dans le panneau BT",
    sslCert: "ssl_certificate",
    sslCertPh: "Saisir ssl_certificate",
    sslCertTip: "Chemin du certificat ssl_certificate",
    sslCertKey: "ssl_certificate_key",
    sslCertKeyPh: "Saisir ssl_certificate_key",
    sslCertKeyTip: "Chemin du certificat ssl_certificate_key",
    dialogTitle: "Instructions",
    redisStep1:
      "Étape 1 : panneau BT → boutique → rechercher redis et l'installer si besoin",
    redisStep2:
      "Étape 2 : paramètres → performance → définir le mot de passe redis",
    swooleStep1:
      "Étape 1 : ouvrir le port 9875 dans le groupe de sécurité cloud",
    swooleStep2: "Étape 2 : ouvrir le port 9875 dans le panneau BT",
    sslStep1:
      "Panneau BT → site → config → copier les chemins SSL ci-dessous",
    detect: "Tester",
  },
};
